<div class="input-group search" [ngClass]="customClass">
    <input type="text" [(ngModel)]="searchQuery" [placeholder]="searchPlaceholder[locale]" class="form-control border-0 g-s-input" (keyup.enter)="navigateToSearch()">
    <span class="input-group-text">
        <a class="btn p-1" [routerLink]="['/search']" [queryParams]="{query:searchQuery}">
            <i class="bi bi-search"></i>
        </a>
    </span>
</div>